import React, { useState, useEffect } from "react";
import { Button, Card, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { BUTTON_TEXT } from "../../constants/Constants";

const DashCardWrapper = ({ icon, title, fields, infoicon, recycleData, carbonEmissionData, supplierSubmittedGoalsData, carbonReportedData, role, isLoading ,error}) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  
  const handleDetailViewClick = () => {
    const basePath = location.pathname.includes("/admin")
      ? "/admin"
      : "/supplier";
    navigate(`${basePath}/detailedview`, { state: { kpiName: title } });
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex justify-center items-center h-[150px]">
          <Spin size="large" />
        </div>
      );
    }
    
    if (error) {
      return (
        <div className="flex justify-center items-center h-[150px] text-gray-500 font-semibold">
          No data available
        </div>
      );
    }
    
    return (
      <div className="space-y-4 mb-[50px]">
        {(!recycleData && !carbonReportedData && !carbonEmissionData && !supplierSubmittedGoalsData) && fields?.map(({ label, value }, index) => (
          <div
            key={index}
            className="flex justify-between items-center text-sm"
          >
            <span className="font-semibold text-[#2C5778] w-[60%]">
              {label}
            </span>
            <span className="font-semibold text-[#2C5778]">:</span>
            <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
              {value}
            </span>
          </div>
        ))}
        {carbonEmissionData && (
          <>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                Emission Avoided
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {carbonEmissionData.totalEmissionAvoided?.toFixed(2)} MTCO2
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                LY Emission Avoided
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {carbonEmissionData.lyTotalEmissionAvoided?.toFixed(2)} MTCO2
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                % Changed
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {carbonEmissionData.percentageChanged?.toFixed(2)} %
              </span>
            </div>
          </>
        )}
        {carbonReportedData && (
          <>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                Emission
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {carbonReportedData?.emissionsByYear?.[2025]?.toFixed(2) || 0.00} MTCO2
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                LY Emission
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
              {carbonReportedData?.emissionsByYear?.[2024]?.toFixed(2) || 0.00} MTCO2
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                % Changed
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {carbonReportedData?.yoY?.toFixed(2) || 0.00}%
              </span>
            </div>
          </>
        )}
        {recycleData && (
          <>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                Recyclable Packaging
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {recycleData?.recyclablePackaging?.toFixed(2)} MT
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                LY Recyclable Packaging
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {recycleData?.lyRecyclablePackaging?.toFixed(2)} MT
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                % Changed
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {recycleData?.percentChangedRecyclablePackaging?.toFixed(2)}%
              </span>
            </div>
          </>
        )}
        {supplierSubmittedGoalsData && (
          <>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                {role=="System Admin"?"TY Supplier Count":"TY Supplier Goals"}
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {role=="System Admin"?supplierSubmittedGoalsData?.tySupplierCount:supplierSubmittedGoalsData.tyTotalGoalCount}
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                {role=="System Admin"?"Ly Supplier Count":"LY Supplier Goals"}
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {role=="System Admin"?supplierSubmittedGoalsData?.lySupplierCount:supplierSubmittedGoalsData.lyTotalGoalCount}
              </span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="font-semibold text-[#2C5778] w-[60%]">
                {role=="System Admin"?"% Changed":"YOY"}
              </span>
              <span className="font-semibold text-[#2C5778]">:</span>
              <span className="font-semibold text-[#2E2E30] w-[40%] text-right">
                {role=="System Admin"?`${supplierSubmittedGoalsData?.supplierCountPercentageChange?.toFixed(2)}%`:supplierSubmittedGoalsData?.goalsYoy}
              </span>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="flex justify-center">
      <Card
        className="w-full bg-white relative border-2 border-[#d1d5dc]"
        bodyStyle={{ paddingBottom: "20px" }}
      >
        <div className="flex items-center gap-1 mb-4">
          <div className="flex items-center justify-center bg-white">
            <img src={icon} alt="icon" className="w-10 h-10" />
          </div>
          <h4 className="flex-1 text-[16px] font-bold text-[#1F405A] m-0">
            {title}
          </h4>
          <img src={infoicon} alt="info" className="w-6 h-6" />
        </div>

        {renderContent()}

        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
          <Button
            onClick={handleDetailViewClick}
            className="w-[150px] bg-[#2C5778] text-[#ffffff]"
            hidden={error || isLoading}
          >
            {BUTTON_TEXT.DETAILS}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default DashCardWrapper;